import React from 'react';
import { Pagination, Filter, List, Edit, Create, SimpleForm, DatagridConfigurable, TextField, TextInput, BooleanInput } from 'react-admin';
import { stripedDataGridSx } from './styles/dataGridStyles';
import Empty from './components/Empty';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

const TruckingCompanyFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
    </Filter>
);

const TruckingCompanyPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export const TruckingCompanyList = props => {
    return (
        <List
            title="Trucking Companies"
            sort={{ field: 'Trucking_Company', order: 'ASC' }}
            perPage={100}
            pagination={<TruckingCompanyPagination />}
            filters={<TruckingCompanyFilter />}
            bulkActionButtons={false}
            empty={<Empty icon={LocalShippingIcon} title="No trucking companies yet" description="Add your first trucking company to get started" />}
            {...props}
        >
            <DatagridConfigurable
                rowClick="edit"
                sx={stripedDataGridSx}
            >
                <TextField label="Company" source="Trucking_Company" />
                <TextField label="Email" source="Carrier_Email" />
                <TextField label="Abbreviation" source="Carrier_Abbreviation" />
                <TextField label="Billing Street" source="Carrier_Billing_Street_Address" />
                <TextField label="Billing City" source="Carrier_Billing_City" />
                <TextField label="Billing Phone" source="Carrier_Contact_Phone" />
            </DatagridConfigurable>
        </List>
    )
}

export const TruckingCompanyEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput label="Company" source="Trucking_Company" />
            <TextInput label="Email" source="Carrier_Email" />
            <TextInput label="Abbreviation" source="Carrier_Abbreviation" />
            <BooleanInput label="Email Trucking Manifest" source="Email_TM_To" />
            <TextInput label="Legal Entity" source="Carrier_Legal_Entity" />
            <TextInput label="Entity Type" source="Carrier_Entity_Type" />
            <TextInput label="SoS Entity" source="Carrier_SoS_Entity_" />
            <TextInput label="Billing Street" source="Carrier_Billing_Street_Address" />
            <TextInput label="Billing City" source="Carrier_Billing_City" />
            <TextInput label="Billing State" source="Carrier_Billing_State" />
            <TextInput label="Billing Zip" source="Carrier_Billing_ZIP" />
            <TextInput label="Contact First Name" source="Carrier_Contact_First_Name" />
            <TextInput label="Contact NickName" source="Carrier_Contact_Nickname" />
            <TextInput label="Contact Last Name" source="Carrier_Contact_Last_Name" />
            <TextInput label="Contact Phone" source="Carrier_Contact_Phone" />
            <TextInput label="Contact Fax" source="Carrier_Contact_Fax" />
            <TextInput label="Email2" source="Carrier_Email2" />
        </SimpleForm>
    </Edit>
);

export const TruckingCompanyCreate = props => (
    <Create
        title="Create Trucking Company"
        redirect="list"
        {...props}
    >
        <SimpleForm>
            <TextInput label="Company" source="Trucking_Company" />
            <TextInput label="Email" source="Carrier_Email" />
            <TextInput label="Abbreviation" source="Carrier_Abbreviation" />
            <BooleanInput label="Email Trucking Manifest" source="Email_TM_To" />
            <TextInput label="Legal Entity" source="Carrier_Legal_Entity" />
            <TextInput label="Entity Type" source="Carrier_Entity_Type" />
            <TextInput label="SoS Entity" source="Carrier_SoS_Entity_" />
            <TextInput label="Billing Street" source="Carrier_Billing_Street_Address" />
            <TextInput label="Billing City" source="Carrier_Billing_City" />
            <TextInput label="Billing State" source="Carrier_Billing_State" />
            <TextInput label="Billing Zip" source="Carrier_Billing_ZIP" />
            <TextInput label="Contact First Name" source="Carrier_Contact_First_Name" />
            <TextInput label="Contact NickName" source="Carrier_Contact_Nickname" />
            <TextInput label="Contact Last Name" source="Carrier_Contact_Last_Name" />
            <TextInput label="Contact Phone" source="Carrier_Contact_Phone" />
            <TextInput label="Contact Fax" source="Carrier_Contact_Fax" />
            <TextInput label="Email2" source="Carrier_Email2" />
        </SimpleForm>
    </Create>
);
